<template>
  <div class="table-bowse-team">
    <v-sheet
      elevation="1"
      class="table-bowse-team-pro"
      rounded
      v-for="item in teamData"
      :key="item._id"
    >
      <p class="href blue--text">
        <!-- {{ item.DateTime | dayFormat }} EST <br />
              {{ item.DateTime | IsoToUtc }} EST <br /> -->
        {{ item.DateTime | IsoToIst }} EST
      </p>

      <!-- temp -->
      <div
        class="mt-n2 desctoptbl"
        v-show="sportsType !== 'NHL' && sportsType !== 'NBA'"
      >
        <v-icon color="blue">mdi-weather-partly-lightning</v-icon>
        <small>
          TempHigh: {{ teamData[0].ForecastTempHigh }}F ({{
            teamData[0].ForecastDescription
          }})
        </small>
        <small> TempLow: {{ teamData[0].ForecastTempLow }}F </small>
      </div>
      <!--//? details header -->
      <v-col class="tabltopcustom">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>
                  <span class="caption font-weight-black">Team Name</span>
                </th>
                <th>
                  <v-img
                    class="mx-1 tlogo"
                    max-height="100"
                    max-width="35"
                    :src="oppLogo"
                    alt="opponent-logo"
                  >
                  </v-img>
                  <span
                    v-if="awayTeam"
                    class="ml-2 d-flex align-center justify-center"
                  >
                    {{ awayTeam.City }} {{ awayTeam.Name }}
                  </span>
                </th>
                <th>
                  <v-img
                    class="mx-1 tlogo"
                    max-height="100"
                    max-width="35"
                    :src="homeLogo"
                    alt="home-logo"
                  >
                  </v-img>
                  <span
                    v-if="awayTeam"
                    class="ml-2 d-flex align-center justify-center"
                  >
                    {{ homeTeam.City }} {{ homeTeam.Name }}</span
                  >
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span class="caption font-weight-black">Money Line</span>
                </td>
                <td>
                  <div>
                    <p v-if="teamData[0].AwayTeamMoneyLine == null">0</p>
                    <span v-else>{{ IsPositive(item.AwayTeamMoneyLine) }}</span>
                  </div>
                </td>
                <td>
                  <div>
                    <p v-if="teamData[0].HomeTeamMoneyLine == null">0</p>
                    <span v-else>{{ IsPositive(item.HomeTeamMoneyLine) }}</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="caption font-weight-black">Point Spread</span>
                </td>
                <td>
                  <div>
                    <p v-if="teamData[0].PointSpread == null">0</p>
                    <p
                      v-else-if="
                        teamData[0].AwayTeamMoneyLine >
                        teamData[0].HomeTeamMoneyLine
                      "
                      class="font-weight-bold green--text"
                    >
                      {{ negToPositive(teamData[0].PointSpread) }}
                    </p>
                    <p v-else class="font-weight-bold green--text">
                      {{ positiveToNeg(teamData[0].PointSpread) }}
                    </p>
                  </div>
                </td>
                <td>
                  <div>
                    <p v-if="teamData[0].PointSpread == null">0</p>
                    <p
                      v-else-if="
                        teamData[0].HomeTeamMoneyLine >
                        teamData[0].AwayTeamMoneyLine
                      "
                      class="font-weight-bold green--text"
                    >
                      {{ negToPositive(teamData[0].PointSpread) }}
                    </p>
                    <p v-else class="font-weight-bold green--text">
                      {{ positiveToNeg(teamData[0].PointSpread) }}
                    </p>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="caption font-weight-black">Total Points</span>
                </td>

                <td>
                  <div>
                    <p v-if="teamData[0].OverUnder == null">0</p>
                    <span>{{ item.OverUnder }}</span>
                  </div>
                </td>
                <td>
                  <div>
                    <p v-if="teamData[0].OverUnder == null">0</p>
                    <span>{{ item.OverUnder }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>

      <!--//? home team details -->
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "NflTeamTable",
  props: {
    teamData: {
      type: Array,
      default: () => [],
    },
    homeLogo: {
      type: String,
      default: "",
    },
    oppLogo: {
      type: String,
      default: "",
    },
    homeTeam: {
      type: Object,
      default: () => {},
    },
    awayTeam: {
      type: Object,
      default: () => {},
    },
    sportsType: {
      type: String,
      default: () => "",
    },
  },

  methods: {
    negToPositive(value) {
      if (value.includes("-")) {
        let negNum = parseFloat(value);
        // let newNum = Math.abs(negNum);
        negNum *= -1;
        return `+${negNum}`;
      } else if (!value.includes("-")) {
        return `+${value}`;
      }
    },

    positiveToNeg(value) {
      if (value.includes("-")) {
        return `${value}`;
      } else if (!value.includes("-")) {
        let negNum = parseFloat(value);
        // let newNum = Math.abs(negNum);
        return `-${negNum}`;
      }
    },

    IsPositive(value) {
      if (!value.includes("-")) {
        return `+${value}`;
      } else {
        return `${value}`;
      }
    },
  },
};
</script>

<style scoped></style>
